import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useGetProductsQuery } from "../../api/productApi";
/* import {
  useGetCategoriesQuery,
  useGetTagsQuery,
} from "../../api/productTaxonomyApi"; */
import type { RootState, AppDispatch } from "../../../../app/store";
import {
  setPagination,
  setPage,
  setSearch,
  setActiveView,
  setPerPage,
  /*   setCategory,
  setTag, */
} from "../../productSlice";
import ProductsDisplay from "./ProductsDisplay";
/* import FilterSidebar from "./FilterSidebar"; */
import ProductsPagination from "./ProductsPagination";
import ProductsTopBar from "./ProductsTopBar";
import { useProductsUrlSync } from "../../hooks";

const ProductsContainer: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { filters, pagination, ui } = useSelector(
    (state: RootState) => state.product
  );

  // Local state for the search input
  const [localSearchTerm, setLocalSearchTerm] = useState(filters.search);

  // Sync URL params with Redux state
  const { urlSyncComplete } = useProductsUrlSync();

  // Sync local search term with Redux store if it changes externally
  useEffect(() => {
    setLocalSearchTerm(filters.search);
  }, [filters.search]);

  // Fetch products
  const {
    data: productsData,
    error: productsError,
    isLoading: productsIsLoading,
    isFetching: productsIsFetching,
  } = useGetProductsQuery(
    {
      category: filters.category.map(String),
      tag: filters.tag.map(String),
      search: filters.search,
      page: pagination.currentPage,
      per_page: pagination.perPage,
      orderby: "menu_order",
      order: "asc",
    },
    { skip: !urlSyncComplete }
  );

  /*   // Fetch categories
  const {
    data: categoriesData,
    error: categoriesError,
    isLoading: categoriesIsLoading,
    isFetching: categoriesIsFetching,
  } = useGetCategoriesQuery();

  // Fetch tags
  const {
    data: tagsData,
    error: tagsError,
    isLoading: tagsIsLoading,
    isFetching: tagsIsFetching,
  } = useGetTagsQuery(); */

  useEffect(() => {
    if (productsData?.pagination) {
      dispatch(
        setPagination({
          totalPages: productsData.pagination.totalPages,
          totalProducts: productsData.pagination.totalProducts,
        })
      );
    }
  }, [productsData, dispatch]);

  const handlePreviousPage = () => {
    if (pagination.currentPage > 1) {
      dispatch(setPage(pagination.currentPage - 1));
    }
  };

  const handleNextPage = () => {
    if (pagination.currentPage < pagination.totalPages) {
      dispatch(setPage(pagination.currentPage + 1));
    }
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setLocalSearchTerm(event.target.value);
  };

  const handleSearchSubmit = () => {
    dispatch(setSearch(localSearchTerm));
  };

  const handleSearchKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      handleSearchSubmit();
    }
  };

  const handleViewChange = (view: "grid" | "list") => {
    dispatch(setActiveView(view));
  };

  const handlePerPageChange = (newPageSize: number) => {
    dispatch(setPerPage(newPageSize));
  };

  const handleClearSearch = () => {
    dispatch(setSearch(""));
    setLocalSearchTerm("");
  };

  /*   // Handler for category selection
  const handleCategorySelect = (categoryId: number) => {
    dispatch(setCategory(categoryId));
  };

  // Handler for tag selection
  const handleTagSelect = (tagId: number) => {
    dispatch(setTag(tagId));
  };

  // Handler for clearing all filters
  const handleClearAllFilters = () => {
    dispatch(setCategory({ action: "clear" }));
    dispatch(setTag({ action: "clear" }));
  }; */

  return (
    <>
      <ProductsTopBar
        searchTerm={localSearchTerm}
        onSearchChange={handleSearchInputChange}
        onSearchSubmit={handleSearchSubmit}
        onKeyDown={handleSearchKeyDown}
        onClearSearch={handleClearSearch}
        activeView={ui.activeView}
        onViewChange={handleViewChange}
        perPage={pagination.perPage}
        onPerPageChange={handlePerPageChange}
        totalProducts={pagination.totalProducts}
        isLoading={productsIsLoading} // Products specific loading
        isFetching={productsIsFetching} // Products specific fetching
        error={productsError} // Products spesific error
      />
      <div className="sidebar-and-products-display-container">
        {/* <FilterSidebar
          categories={categoriesData?.categories}
          tags={tagsData?.tags}
          selectedCategories={filters.category}
          selectedTags={filters.tag}
          onCategorySelect={handleCategorySelect}
          onTagSelect={handleTagSelect}
          onClearFilters={handleClearAllFilters}
          isLoading={categoriesIsLoading || tagsIsLoading} // Taxonomy specific loading
          isFetching={categoriesIsFetching || tagsIsFetching} // Taxonomy specific fetching
          error={categoriesError || tagsError} // Taxonomy specific error
        /> */}
        <main className="products-main-content">
          <ProductsDisplay
            products={productsData?.products || []}
            isLoading={productsIsLoading} // Products specific loading
            isFetching={productsIsFetching} // Products specific fetching
            error={productsError} // Products spesific error
            activeView={ui.activeView}
          />
          {productsData && productsData.products.length > 0 && (
            <ProductsPagination
              pagination={pagination}
              onPreviousPage={handlePreviousPage}
              onNextPage={handleNextPage}
              isLoading={productsIsLoading} // Products specific loading
              isFetching={productsIsFetching} // Products specific fetching
              error={productsError} // Products spesific error
            />
          )}
        </main>
      </div>
    </>
  );
};

export default ProductsContainer;
